const cardStatuses = [
    {id: 'active',name: 'active'},
    {id: 'blocked',name: 'blocked'},
];

export default cardStatuses;